import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  opacity: 0.1;
  font-weight: 200;
  height: 500px;
`;
